import { Component, Input, Output, EventEmitter, OnInit, HostListener, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSidenav } from '@angular/material/sidenav';
import { HeaderComponent, HeaderConfig } from '../header/header.component';
import { SidebarComponent, SidebarConfig, NavItem } from '../sidebar/sidebar.component';

@Component({
  selector: 's-app-layout',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavModule,
    HeaderComponent,
    SidebarComponent
  ],
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.scss'
})
export class AppLayoutComponent implements OnInit {
  @ViewChild('sidenav') sidenav!: MatSidenav;
  
  @Input() headerConfig: HeaderConfig = { title: 'Application' };
  @Input() sidebarConfig: SidebarConfig = { navItems: [] };
  @Input() breakpoint: number = 768;
  
  @Output() navItemClick = new EventEmitter<NavItem>();
  @Output() layoutChange = new EventEmitter<{ isMobile: boolean; sidebarOpen: boolean }>();
  
  // Internal state
  isMobile = false;
  sidebarMode: 'side' | 'over' = 'side';
  sidebarOpen = true;

  ngOnInit() {
    this.checkScreenSize();
    this.updateHeaderConfig();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
    this.updateHeaderConfig();
  }

  private checkScreenSize() {
    this.isMobile = window.innerWidth <= this.breakpoint;
    
    if (this.isMobile) {
      this.sidebarMode = 'over';
      this.sidebarOpen = false;
    } else {
      this.sidebarMode = 'side';
      this.sidebarOpen = true;
    }
    
    this.emitLayoutChange();
  }

  private updateHeaderConfig() {
    this.headerConfig = {
      ...this.headerConfig,
      showMenuButton: this.isMobile
    };
  }

  private emitLayoutChange() {
    this.layoutChange.emit({
      isMobile: this.isMobile,
      sidebarOpen: this.sidebarOpen
    });
  }

  onMenuToggle() {
    if (this.sidenav) {
      this.sidenav.toggle().then(() => {
        this.sidebarOpen = this.sidenav.opened;
        this.emitLayoutChange();
      });
    }
  }

  onNavItemClick(item: NavItem) {
    this.navItemClick.emit(item);
    
    // Close sidebar on mobile after navigation
    if (this.isMobile && this.sidenav) {
      this.sidenav.close().then(() => {
        this.sidebarOpen = false;
        this.emitLayoutChange();
      });
    }
  }
} 